<template>
  <section>
    <v-container fluid>
      <v-row class="justify-between align-center">
        <v-col cols="auto" class="ml-auto">
          <v-text-field
            filled
            rounded
            dense
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>

    <v-card class="shadow-1">
      <v-data-table
        :headers="headers"
        :items="breaksList"
        :loading="isLoadingTable"
        :search="search"
        :footer-props="{
          'items-per-page-options': [15, 30, 50, 100],
        }"
      >
        <template v-slot:[`item.duration`]="{ item }">
          <span v-if="Boolean(item.duration)">
            {{ tem.duration | secondsToTimeFormat }}
          </span>
          <time-counter v-else :item="item"></time-counter>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          {{ statusList[item.status] }}
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-btn icon @click="openConfirmClose(item.id)">
            <v-icon>mdi-exit-to-app</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog
      :value="isConfirmDialog"
      @click:outside="isConfirmDialog = false"
      max-width="500"
    >
      <v-card>
        <v-progress-linear
          v-if="isLoading"
          indeterminate
          color="primary"
          rounded
          height="6"
        ></v-progress-linear>

        <v-card-title class="pa-0 shadow-1">
          <v-img
            :src="require('@/assets/illustrations/bg_modal_card.svg')"
            cover
            position="left bottom"
            class="align-center"
            height="65px"
          >
            <v-card-title class="font-weight-medium primary--text">
              Cerrar Pausa
            </v-card-title>
          </v-img>
        </v-card-title>

        <v-card-text style="max-height: 350px">
          <v-row dense>
            <v-col cols="12">
              <p class="font-weight-medium text-h6">
                Esta seguro que desea cerrar esta pausa?
              </p>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="mx-2">
          <v-spacer></v-spacer>
          <v-hover v-slot:default="{ hover }">
            <v-btn
              text
              rounded
              class="mr-1"
              :color="hover ? 'error' : 'grey'"
              @click="isConfirmDialog = false"
            >
              Cancelar
            </v-btn>
          </v-hover>

          <v-hover v-slot:default="{ hover }">
            <v-btn
              rounded
              :loading="isLoading"
              :disabled="isLoading"
              color="error"
              :class="hover ? 'shadow-2' : 'shadow-4'"
              class="px-8"
              @click="closePause()"
            >
              Cerrar
            </v-btn>
          </v-hover>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import moment from "moment";
import { PbxHttpClient } from "@/services/httpclient";
import TimeCounter from "@/components/Breaks/TimeCounter.vue";
export default {
  components: { TimeCounter },
  data() {
    return {
      isLoading: false,
      isLoadingTable: true,
      isConfirmDialog: false,
      search: "",
      headers: [
        {
          text: "Agente",
          align: "left",
          value: "user.name",
          class: "primary--text",
          width: "15%",
        },
        {
          text: "Extension",
          align: "left",
          value: "user.extension",
          class: "primary--text",
          width: "15%",
        },
        {
          text: "Pausa",
          align: "left",
          value: "pause.name",
          class: "primary--text",
          width: "10%",
        },
        {
          text: "Fecha de Inicio",
          value: "created_at",
          class: "primary--text",
          width: "25%",
        },
        {
          text: "Duracion",
          value: "duration",
          class: "primary--text",
          width: "15%",
        },
        // {
        //     text: "Estado",
        //     value: "status",
        //     class: "primary--text",
        //     width: "10%"
        // },
        {
          text: "Acciones",
          value: "action",
          class: "primary--text",
          width: "10%",
          align: "center",
          sortable: false,
        },
        // { text: "", value: "data-table-expand", width: "5%" }
      ],
      breaksList: [],
      statusList: {
        0: "Eliminado",
        1: "Conectado",
        2: "Pausado",
        3: "Bloqueado",
      },
      pauseToDelete: null,
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
    };
  },
  async created() {
    await this.getBreaks();
  },
  methods: {
    openConfirmClose(pauseId) {
      this.pauseToDelete = pauseId;
      this.isConfirmDialog = true;
    },
    async getBreaks() {
      try {
        const { data } = await PbxHttpClient.get("/agent/use_pause/");
        // console.log("agents", data.data);
        this.breaksList = data.data;
      } catch (error) {
        this.$snotify.error("Hubo un error en la consulta", "Error");
        // console.log(error);
      }
      this.isLoadingTable = false;
    },
    async closePause() {
      this.isLoading = true;
      try {
        await PbxHttpClient.put(`/agent/use_pause/${this.pauseToDelete}`);
        // await new Promise((res, rej) => {
        //     setTimeout(() => {
        //         res("done");
        //     }, 2000);
        // });
        this.breaksList = this.breaksList.filter(
          (e) => e.pause_id !== this.pauseToDelete
        );
        this.pauseToDelete = null;
        this.$snotify.success("Pausa cerrada con éxito.", "¡Hecho!");
        this.isConfirmDialog = false;
      } catch (err) {
        this.$snotify.error("Hubo un error cerrando la pausa", "Error");
      }

      this.isLoading = false;
    },
  },
};
</script>

<style></style>
